import {
  getReservationTop10,
  ResGetReservationTop10,
} from '@/service/tour/main/getReservationTop10';
import { useQuery } from '@tanstack/react-query';
import { RQMainKey } from './RQMainKey';

export const useReservationTop10Query = () => {
  return useQuery<ResGetReservationTop10, Error, ResGetReservationTop10['result']>({
    queryKey: RQMainKey.reservationTop10,
    queryFn: getReservationTop10,
    select: (data) => data.result,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
  });
};
